import { throwError } from 'rxjs'
import { ajax } from 'rxjs/ajax'
import { catchError } from 'rxjs/operators'
import { env } from 'shared/env'

const baseURL = env.SERVER_ADDR

const requestHeader = () => {
  const headers = {
    'Content-Type': 'application/json',
  }
  const userData = JSON.parse(localStorage.getItem('user_info') || '{}')
  let token: string | boolean = false
  if (userData.token) {
    token = userData.token
  }
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }

  return headers
}

const handleError = (operation: string) => (err: any) => {
  const errMsg = `Error in ${operation}()`

  if (err.status === 401) {
    localStorage.clear()
    window.location.href = '/auth/login'
  }
  return throwError(() => console.error(errMsg))
}

export const getCustomers = (payload) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/customer?page=${payload.page}&per_page=${
      payload.perPage
    }&search=${payload.search || ''}`,
    body: payload,
  }).pipe(catchError(handleError('login')))

export const getCustomerByID = (id) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/customer/${id}`,
  }).pipe(catchError(handleError('login')))

export const addNewCustomer = (data) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/customer`,
    body: data,
  }).pipe(catchError(handleError('login')))

export const UpdateCustomerInfo = (data) =>
  ajax({
    headers: requestHeader(),
    method: 'PUT',
    withCredentials: false,
    url: `${baseURL}api/v2/customer/${data.customer_id}`,
    body: data,
  }).pipe(catchError(handleError('login')))

export const deleteCustomerAddress = (customer_id, id) =>
  ajax({
    headers: requestHeader(),
    method: 'DELETE',
    withCredentials: false,
    url: `${baseURL}api/v2/customer/${customer_id}/address/${id}`,
  }).pipe(catchError(handleError('deleteCustomerAddress')))

export const addCustomerAddress = (data) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/customer/${data.customer_id}/address`,
    body: data,
  }).pipe(catchError(handleError('login')))

export const deleteCustomerPaymentMethod = (customer_id, id) =>
  ajax({
    headers: requestHeader(),
    method: 'DELETE',
    withCredentials: false,
    url: `${baseURL}api/v2/customer/${customer_id}/payment-method/${id}`,
  }).pipe(catchError(handleError('login')))

export const createCustomerInvoice = (data) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/invoice`,
    body: data,
  }).pipe(catchError(handleError('login')))

export const UpdateCustomerAddress = (data) =>
  ajax({
    headers: requestHeader(),
    method: 'PUT',
    withCredentials: false,
    url: `${baseURL}api/v2/customer/${data.customer_id}/address/${data.address_id}`,
    body: data,
  }).pipe(catchError(handleError('login')))

export const unmapPickupAddress = (data) =>
  ajax({
    headers: requestHeader(),
    method: 'DELETE',
    withCredentials: false,
    body: data,
    url: `${baseURL}api/v2/courier/pickup-address/warehouse-mapping`,
  }).pipe(catchError(handleError('unmapPickupAddress')))
